export default class AsyncLimit {
	constructor(limit, allowError) {
		this.limit = limit;
		this.running = []; // 正在执行的
		this.queue = []; // 排除中的
		this.allowError = allowError == null ? true : allowError;
	}
	/**
	 * 清空队列并停止执行
	 * @returns {Promise<any[]>}
	 */
	clear() {
		this.queue.length = 0;
		let list = [];
		while (this.running.length) {
			let node = this.running.pop();
			console.log(node);
			if (node && typeof node.kill === "function") list.push(node.kill());
		}
		return Promise.all(list);
	}
	/** */
	remove(_opt) {
		var idx = this.queue.indexOf(_opt);
		if (idx >= 0) this.queue.splice(idx, 1);
	}
	/**
	 *
	 * @param {object|()=>Promise<any>} opt
	 * @param {()=>Promise<any>} [opt.run]
	 */
	push(opt) {
		if (typeof opt === "function") opt = {run: opt};
		if (typeof opt.run != "function") throw new Error("opt.run is not a function");
		if (this.running.length < this.limit) {
			let pms = (opt._pms = opt.run());
			this.running.push(opt);
			pms.then(
				() => {
					let idx = this.running.indexOf(opt);
					if (idx > -1) this.running.splice(idx, 1);
					if (this.queue.length) this.push(this.queue.shift());
					else if (!this.running.length) this.resolve();
				},
				(err) => {
					let idx = this.running.indexOf(opt);
					if (idx > -1) this.running.splice(idx, 1);
					if (this.allowError) {
						if (this.queue.length) this.push(this.queue.shift());
						else if (!this.running.length) this.resolve();
					} else {
						this.reject(err);
						this.queue.length = 0;
					}
				}
			);
			if (!this._pms) {
				if (this.reject) this.reject("user abort");
				this._pms = new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
				this._pms.finally(() => (this._pms = null));
			}
		} else this.queue.push(opt);
		return opt;
	}
	wait() {
		if (!this._pms) return Promise.resolve();
		return this._pms;
	}
}
